import { monthRangeForYearMonth, rangeLabel } from "./date-range";
import { ymAddMonths } from "./pace";

export interface GoalCoverageRow {
    goalMonths: string[];
}

export const monthsWithoutGoals = (months: string[], goalMonths: string[]): string[] => {
    const covered = new Set(goalMonths);
    return months.filter(month => !covered.has(month));
};

export const monthsWithoutTeamGoals = (
    months: string[],
    rows: GoalCoverageRow[],
): string[] =>
    monthsWithoutGoals(
        months,
        rows.flatMap(row => row.goalMonths),
    );

const runLabel = (first: string, last: string): string =>
    rangeLabel({
        start: monthRangeForYearMonth(first).start,
        end: monthRangeForYearMonth(last).end,
    });

export const formatMonthRuns = (months: string[]): string => {
    const [first, ...rest] = [...months].sort();
    if (first === undefined) {
        return "";
    }
    const runs: string[] = [];
    let runStart = first;
    let previous = first;
    for (const month of rest) {
        if (month !== ymAddMonths(previous, 1)) {
            runs.push(runLabel(runStart, previous));
            runStart = month;
        }
        previous = month;
    }
    runs.push(runLabel(runStart, previous));
    return runs.join(", ");
};
